import { render, staticRenderFns } from "./WariwariLanding.vue?vue&type=template&id=4f74faf3&"
import script from "./WariwariLanding.vue?vue&type=script&lang=js&"
export * from "./WariwariLanding.vue?vue&type=script&lang=js&"
import style0 from "./WariwariLanding.vue?vue&type=style&index=0&id=4f74faf3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports